import { render } from "preact";

import { App } from "@/App";
import { canonicalUrl } from "@/lib/canonicalHost";
import { startRouting } from "@/state/route";
import "@/styles/app.css";

const root = document.getElementById("app");
if (!root) throw new Error("missing #app root");
const address = canonicalUrl(window.location);
if (address) {
  // One of the site's default domains: the dashboard lives at its address.
  window.location.replace(address);
} else {
  // Before the first render, so a shared link opens its view straight away.
  startRouting();
  render(<App />, root);
}
